import { render, staticRenderFns } from "./update-phone.vue?vue&type=template&id=422d2a22&scoped=true"
import script from "./update-phone.vue?vue&type=script&lang=ts"
export * from "./update-phone.vue?vue&type=script&lang=ts"
import style0 from "./update-phone.vue?vue&type=style&index=0&id=422d2a22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d2a22",
  null
  
)

export default component.exports